import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Button, Card, Table, Badge, Spinner, Alert } from "react-bootstrap";
import { showSuccessMessage, showErrorMessage } from "../utils/alertHelper";

import "bootstrap/dist/css/bootstrap.min.css";
import { Container,Tab, Tabs} from "react-bootstrap";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import TopNavbar from "../components/TopNavbar";

const InvoiceDetail = () => {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
        // Theme Management
        useEffect(() => {
          document.body.className = theme;
          localStorage.setItem("theme", theme);
        }, [theme]);
      
        const toggleTheme = () => {
          setTheme(theme === "light" ? "dark" : "light");
        };
        const [user, setUser] = useState(null);

  const { invoice_id } = useParams();
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_BASE_URL;
  const token = localStorage.getItem("token");


useEffect(() => {
    const fetchInvoice = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${baseURL}/invoices/${invoice_id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        console.log("API Response:", response.data); // Debug log
        
        // Handle different response structures
        const invoiceData = response.data.data || response.data;
        
        if (!invoiceData) {
          throw new Error("No invoice data received");
        }
        
        setInvoice({
          ...invoiceData,
          items: invoiceData.items || [],
          customer: invoiceData.customer || {
            name: invoiceData.customer_name,
            phone: invoiceData.customer_phone,
            address: invoiceData.customer_address
          }
        });
        
      } catch (error) {
        console.error("Error fetching invoice:", error);
        setError(error.response?.data?.message || error.message);
        showErrorMessage("Failed to load invoice details");
      } finally {
        setLoading(false);
      }
    };
    
    fetchInvoice();
  }, [invoice_id, baseURL, token]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center mt-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mt-4">
        <Alert variant="danger">
          <Alert.Heading>Error Loading Invoice</Alert.Heading>
          <p>{error}</p>
          <Button variant="primary" onClick={() => navigate("/invoice")}>
            Back to Invoices
          </Button>
        </Alert>
      </div>
    );
  }

  if (!invoice) {
    return (
      <div className="container mt-4">
        <Alert variant="warning">
          <Alert.Heading>Invoice Not Found</Alert.Heading>
          <p>No invoice found with ID: {invoice_id}</p>
          <Button variant="primary" onClick={() => navigate("/invoice")}>
            Back to Invoices
          </Button>
        </Alert>
      </div>
    );
  }

  return (
    <div className={`dashboard ${theme}`}>
<Container fluid className={` ${theme === "dark" ? "bg-dark text-white" : "bg-light text-dark"}`}>
    <TopNavbar user={user} toggleTheme={toggleTheme} theme={theme} />

    <div className="container-fluid p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Invoice #{invoice.ref || invoice.invoice_id}</h2>
        <Button variant="primary" onClick={() => navigate("/invoice")}>
          Back to Invoices
        </Button>
      </div>

      <Card  className={`mb-4 ${
          theme === "dark" ? "bg-dark text-white" : "bg-light text-dark"
        }`}>
        <Card.Body>
          <div className="row mb-4">
            <div className="col-md-6">
              <h5>From:</h5>
              <p>
                {invoice.business_name || "Your Business Name"}<br />
                {invoice.business_address || "123 Business Address"}<br />
                {invoice.business_city || "City, Country"}
              </p>
            </div>
            <div className="col-md-6 text-end">
              <h5>To:</h5>
              <p>
                {invoice.customer?.name || invoice.customer_name || "Customer Name"}<br />
                {invoice.customer?.phone || invoice.customer_phone || "N/A"}<br />
                {invoice.customer?.address || invoice.customer_address || "N/A"}
              </p>
            </div>
          </div>

          <Table striped bordered className={`float-end ${
                                theme === "dark" ? "table-dark" : "table-light"
                              }`}>
            <thead>
              <tr>
                <th>#</th>
                <th>Description</th>
                <th>Qty</th>
                <th>Price</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {invoice.items?.length > 0 ? (
                invoice.items.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.product_name || item.description || "Item"}</td>
                    <td>{item.quantity || 0}</td>
                    {/* <td>£{(item.price || 0).toFixed(2)}</td> */}
                    <td>${Number(item.price || 0).toFixed(2)}</td>
                    <td>${Number(item.grand_total || 0).toFixed(2)}</td>
                    {/* <td>£{(item.total || 0).toFixed(2)}</td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">No items found in this invoice</td>
                </tr>
              )}
            </tbody>
          </Table>

          <div className="row mt-4">
            <div className="col-md-6">
              <p><strong>Notes:</strong> {invoice.additional_info.notes || "N/A"}</p>
              <p><strong>Date:</strong> {invoice.dates.invoice_date}</p>
              <p><strong>Due Date:</strong> {invoice.dates.due_date}</p>
            </div>
            <div className="col-md-6">
              <Table borderless className={`float-end ${
                                theme === "dark" ? "table-dark" : "table-light"
                              }`} style={{ width: '300px' }}>
                <tbody>
                  <tr>
                    <td><strong>Subtotal:</strong></td>
                    <td className="text-end">${Number(invoice.financials?.subtotal || 0).toFixed(2)}</td>
                  </tr>
                  <tr>
                  <td>Discount:</td>
                  <td className="text-end">${Number(invoice.financials?.discount || 0).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td><strong>Tax:</strong></td>
                    <td className="text-end">${Number(invoice.financials?.tax || 0).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td><strong>Total:</strong></td>
                    <td className="text-end">${Number(invoice.financials?.total || 0).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td><strong>Status:</strong></td>
                    <td className="text-end">
                      <Badge bg={invoice.status_info.invoice_status === "paid" ? "success" : "warning"}>
                        {invoice.status_info.invoice_status || "unknown"}
                      </Badge>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>

    </Container>
                </div>
  );
};

export default InvoiceDetail;